import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  actionsWrap: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}));

export default function PlaneadorActions({onBack = null, onSave, backLabel = "Volver", saveLabel = "Guardar", saving = false}) {
  const classes = useStyles();
  return (
    <div className={classes.actionsWrap}>
      {onBack && (
        <Button
          variant="outlined"
          size="small"
          onClick={onBack}
        >
          {backLabel}
        </Button>
      )}
      {onSave && (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={onSave}
          disabled={saving}
        >
          {saving ? "Guardando..." : saveLabel}
        </Button>
      )}
    </div>
  );
}
